const password = {
    unsupported_encryption_method: 'Метод шифрования {{name}} не поддерживается.',
    pepper_not_found: 'Не найден пепер пароля. Пожалуйста, проверьте ваши основные envs.',
};
export default password;
